(() => {
  if (window.mapsyVariantSoldoutButtons20260630) return;
  window.mapsyVariantSoldoutButtons20260630 = true;

  const selectedOptions = (selector) =>
    [...selector.querySelectorAll(".product-form__controls")].map((fieldset) => {
      const select = fieldset.querySelector("select");
      if (select) return select.value;
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

  const variantData = (selector) => {
    try {
      if (typeof selector.getVariantData === "function") return selector.getVariantData();
      return JSON.parse(selector.querySelector('[type="application/json"]')?.textContent || "[]");
    } catch (error) {
      return [];
    }
  };

  const labelFor = (input) => {
    if (!input.id) return input.nextElementSibling;
    const escaped = window.CSS && CSS.escape ? CSS.escape(input.id) : input.id.replace(/"/g, '\\"');
    return document.querySelector(`label[for="${escaped}"]`) || input.nextElementSibling;
  };

  const setSoldout = (control, soldOut, variant) => {
    control.classList.toggle("disabled", soldOut);
    control.dataset.mapsySoldout = soldOut ? "true" : "false";
    if (variant) control.dataset.mapsyVariantId = String(variant.id);

    const item = control.closest(".swatches-list-item");
    const label = labelFor(control);
    item?.classList.toggle("mapsy-option-soldout", soldOut);
    if (!label) return;

    label.classList.toggle("mapsy-option-soldout", soldOut);
    label.dataset.mapsySoldout = soldOut ? "true" : "false";
    label.setAttribute("aria-label", soldOut ? `${control.value} - Uitverkocht` : control.value);
    label.setAttribute("title", soldOut ? `${control.value} - Uitverkocht` : control.value);
  };

  const updateSelector = (selector) => {
    const variants = variantData(selector);
    const fieldsets = [...selector.querySelectorAll(".product-form__controls")];
    const selected = selectedOptions(selector);
    if (!variants.length || !fieldsets.length) return;

    fieldsets.forEach((fieldset, optionIndex) => {
      [...fieldset.querySelectorAll('input[type="radio"], option')].forEach((control) => {
        const value = control.getAttribute("value");
        if (value == null) return;

        const candidate = selected.slice();
        candidate[optionIndex] = value;
        const variant = variants.find((variant) =>
          variant.options.every((optionValue, index) => candidate[index] == null || candidate[index] === optionValue)
        );
        setSoldout(control, !(variant && variant.available), variant);
      });
    });
  };

  const normaliseSoldoutButtons = () => {
    document
      .querySelectorAll('button.addtocart-button[disabled], button.addtocart-button[aria-disabled="true"]')
      .forEach((button) => {
        button.classList.add("mapsy-atc-soldout");
        const text = button.querySelector("[data-addtocart-text], .button-text, span");
        if (text && /soldout|sold out|uitverkocht/i.test(text.textContent.trim())) {
          text.textContent = "Niet op voorraad";
        }
      });

    document
      .querySelectorAll('button.addtocart-button:not([disabled]):not([aria-disabled="true"])')
      .forEach((button) => button.classList.remove("mapsy-atc-soldout"));
  };

  const updateAll = () => {
    document.querySelectorAll("variant-selector").forEach(updateSelector);
    normaliseSoldoutButtons();
  };

  const queue = () => {
    requestAnimationFrame(updateAll);
    setTimeout(updateAll, 80);
    setTimeout(updateAll, 650);
  };

  document.addEventListener("change", (event) => {
    if (event.target.closest?.("variant-selector")) queue();
  });
  document.addEventListener("shopify:section:load", queue);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", queue, { once: true });
  } else {
    queue();
  }
})();
